import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { useEffect, useState } from 'react';
import { Cookies } from 'react-cookie';
import { useNavigate } from "react-router-dom";
import { API_SERVER } from '../../EnvConfig/env_config';
import { getCommonData } from '../Common/CommanServices';
import { OpenBase64Pdf, setFocus, setTitle, ReverseFormatDate, GetDate } from "../Common/Common";
import { AlertBox, AutoCompleteBox } from '../Common/Input';
import { post } from '../Common/service';
import Loader from '../Layout/Loader';

const StockReturn = ({ open, setOpen }) => {
    const cookies = new Cookies();
    const Token = cookies.get('token')
    const navigate = useNavigate();
    const LoginUserCode = cookies.get('loginUserCode');
    const WarehouseName = cookies.get('warehouseName');
    const WarehouseCode = cookies.get('warehouseCode')
    const [isLoading, setIsLoading] = useState(false);
    const [tableLoading, setTableLoading] = useState(false);
    const [fromWareHouse, setFromWareHouse] = useState([])
    const [toWareHouseData, setToWarehouseData] = useState([])

    const [MenuText, setMenuText] = useState("Stock Return");


    const [filterData, setFilterData] = useState({
        SearchFieldValue: "",
        SearchText: "",
        StartValue: "1",
        PageIndex: "1",
    })

    const [formData, setformData] = useState({
        TransferNo: "Syatem-Generated",
        fromWareHouse: WarehouseCode ? WarehouseCode + ' : ' + WarehouseName : "",
        toWareHouse: 'CW : Central Warehouse',
        stockTransferDate: GetDate(0),
        ReturnedItemDetails: [

        ]
    });
    const getFromWareHouse = () => {
        setFromWareHouse([]);
        let temp = {
            Type: "GetWareHouse",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        };
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token,
            LoginUserCode: loginCodeString
        };

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let fromWareHouse = res.autoCompleteData || [];
                setFromWareHouse(fromWareHouse);
            } else {
                console.error("Error fetching From Ware House data:", res.message);
                setFromWareHouse([]);
            }
        });
    };
    let FromWareHouseArr = []
    for (let i = 0; i < fromWareHouse.length; i++) {
        let mydata = fromWareHouse[i]?.values
        FromWareHouseArr.push(mydata)
    };
    const getToWareHouse = () => {
        setToWarehouseData([]);
        let temp = {
            Type: "GetStockToWareHouse",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        };
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token,
            LoginUserCode: loginCodeString
        };

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let WareHouseData = res.autoCompleteData || [];
                setToWarehouseData(WareHouseData);
            } else {
                console.error("Error fetching salesperson data:", res.message);
                setToWarehouseData([]);
            }
        });
    };
    let ToWarehouseArr = []
    for (let i = 0; i < toWareHouseData.length; i++) {
        let mydata = toWareHouseData[i]?.values
        ToWarehouseArr.push(mydata)
    };
    const handleClear = () => {

        setformData({
            ...formData,
            fromWareHouse: WarehouseCode ? WarehouseCode + ' : ' + WarehouseName : "",
            toWareHouse: 'CW : Central Warehouse',
            ReturnedItemDetails: []
        });
        setFocus('txtFromWareHouse');
    }
    useEffect(() => {
        setTitle('StockReturn', setOpen);
        setTimeout(() => {
            setMenuText(document.title);
        }, 500)
    }, []);

    useEffect(() => {
        setFocus('txtFromWareHouse');
    }, [filterData.PageIndex]);

    const handleSubmit = async () => {
        setIsLoading(true)
        const loginCodeString = String(LoginUserCode);
        let data = {
            ...formData, Token, LoginUserCode: loginCodeString
        }
        console.log(formData, "formData")
        post(`${API_SERVER}/api/Operation/SaveStockReturn`, { ...data }, (res) => {

            if (res.status === 'SUCCESS') {
                AlertBox(res.status, res.message, res.focus);
                handleClear()
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus);
            }
            if (res.focus !== "") {
                setFocus(res.focus)
            }
            setIsLoading(false);
        })
    }
    const handlePrintData = (ID,) => {
        const loginCodeString = String(LoginUserCode);

        const data = {
            ...filterData,
            Source: "",
            fromWareHouse: formData.fromWareHouse,
            toWareHouse: 'CW : Central Warehouse',//formData.toWareHouse,
            Token,
            LoginUserCode: loginCodeString
        };
        post(`${API_SERVER}/api/Print/StockReturnPrint`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                OpenBase64Pdf(res.documentPdfBase64, 'StockReturnPrint_' + ID, '_blank');
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            if (res.status === 'ERROR' || res.message !== '') {
                AlertBox(res.status, res.message, res.focus);
            }
            if (res.focus !== "") {
                setFocus(res.focus);
            }
        })
    }
    const GetsalesPersonWiseInhandData = () => {
        const loginCodeString = String(LoginUserCode);
        const data = {
            ...formData, Token, LoginUserCode: loginCodeString, ...filterData
        }
        setTableLoading(true)
        post(`${API_SERVER}/api/Operation/GetsalesPersonWiseInhandData`, { ...data }, (res) => {
            setformData({
                ...formData,
                ReturnedItemDetails: []
            });
            if (res.Status === 'SUCCESS') {
                let returnedItemDetails = [];
                res.Data.forEach((item, index) => {
                    let Item = {};
                    Item.ItemCode = item.ItemCode;
                    Item.ItemNo = item.ItemNo;
                    Item.QuantiyInHand = item.QuantiyInHand;
                    Item.ReturnQuantity = item.ReturnQuantity;

                    returnedItemDetails.push(Item);
                });
                setformData({
                    ...formData,
                    ReturnedItemDetails: returnedItemDetails
                });
            }
            else if (res.Message === "EXPIRED") {
                navigate('/Login')
            }
            if (res.Status === "ERROR") {
                AlertBox(res.Status, res.Message, res.focus);
            }
        })
    }

    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{MenuText}</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area">
                                <div className="row align-items-end">
                                    <div className="col-lg-3 col-md-3 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Stock Transfer No<span className="Required">*</span></label>

                                            <input
                                                id='txtTransferNo'
                                                maxLength="50"
                                                type="text"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('txtFromWareHouse');
                                                    };
                                                }}
                                                disabled
                                                className="form-control"
                                                placeholder='Enter Stock No'
                                                value={formData.TransferNo}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-4 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                label='From Ware House'
                                                placeholder="From Ware House"
                                                maxLength='100'
                                                disabled={WarehouseCode ? true : false}
                                                options={FromWareHouseArr}
                                                id='txtFromWareHouse'
                                                required={true}
                                                ignore_common={true}
                                                onFocus={() => getFromWareHouse()}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtToWareHouse") };
                                                }}
                                                inputValue={formData.fromWareHouse ? formData.fromWareHouse : ''}
                                                onInputChange={(event, newInputValue) => {
                                                    setformData({ ...formData, fromWareHouse: newInputValue })
                                                }}
                                            />

                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                label='To Ware House'
                                                placeholder="To Ware House"
                                                maxLength='100'
                                                disabled
                                                options={ToWarehouseArr}
                                                id='txtToWareHouse'
                                                required={true}
                                                ignore_common={true}
                                                onFocus={() => getToWareHouse()}
                                                inputValue={formData.toWareHouse ? formData.toWareHouse : 'CW : Central Warehouse'}
                                                onInputChange={(event, newInputValue) => {
                                                    setformData({ ...formData, toWareHouse: newInputValue })
                                                }}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("btnSearch") };
                                                }}
                                            />

                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Stock Transfer Date </label>
                                            <DatePicker selected={ReverseFormatDate(GetDate(0))}
                                                disabled='disabled'
                                                id='txtStockReturnDate'
                                                className="form-control"
                                                placeholderText='Select Stock Transfer Date'
                                                dateFormat={'dd-MMM-yyyy'}
                                                autoComplete='off'

                                                maxDate={new Date()}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('btnSearch');
                                                    };
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-12 mt-4">
                                        <div className="lms-new-button text-center">
                                            <button className="button save-btn" id='btnSearch' onClick={GetsalesPersonWiseInhandData}>
                                                <i className="bi bi-search" /> Search
                                            </button>
                                            <button className="button save-btn" id='btnSave' onClick={handleSubmit}>
                                                <i className="bi bi-check-lg" /> Save
                                            </button>
                                            <button className="button print-btn" onClick={handlePrintData} >
                                                <i className="bi bi-printer" /> Print
                                            </button>
                                            <button className="button reset-btn" onClick={handleClear}>
                                                <i className="bi bi-arrow-clockwise" /> Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <>  {
                formData ? (
                    <div className="col-lg-12 col-md-12 col-sm-12 mt-5">

                        <div className="recoard-bata service-content-area" style={{ padding: '0rem 0rem 0rem 0rem' }}>
                            <div className="table-responsive">
                                <table className="table table-bordered table-striped">
                                    <thead>
                                        <tr className='light-bg'>
                                            <th>Item Code</th>
                                            <th>Item Name</th>
                                            <th>Quantity Inhand</th>
                                            <th>Quantity</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {formData.ReturnedItemDetails?.map((item, bodyIndex) => (
                                            <tr className="TableTrhover" key={`row${bodyIndex}`}  >
                                                <td>{item.ItemCode}</td>
                                                <td>{item.ItemNo}</td>
                                                <td>{item.QuantiyInHand}</td>
                                                <td><input className="form-control" type='text'
                                                    id={`txtQuantity${bodyIndex}`}
                                                    style={{ minWidth: '70px' }}
                                                    maxLength="10"
                                                    value={item.ReturnQuantity}
                                                    onChange={(e) =>
                                                        setformData(prevSaveData => ({
                                                            ...prevSaveData,
                                                            ReturnedItemDetails: prevSaveData.ReturnedItemDetails.map((item, i) => {
                                                                if (i === bodyIndex) {
                                                                    return { ...item, ReturnQuantity: e.target.value };
                                                                }
                                                                return item;
                                                            })
                                                        }))
                                                    }
                                                /> </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div >

                ) : (<> </>)
            }
                {/* Loder start*/}

                {/* Loder End*/}
            </>

            {isLoading ? <Loader text='Please wait' size='100px' img_path='./assets/img/giphy.gif' /> : <></>}

        </main>
    )
}
export default StockReturn